import { ProfilePage } from '@mobi/web';
import { Fleet } from '../components/Fleet.js';

export function Profile() {
  return <ProfilePage extra={<Fleet />} />;
}
